<!--
  @component
  Generates an SVG area shape using the `area` function from [d3-shape](https://github.com/d3/d3-shape) and sets the color via an ordinal scale in `zScale`. It assumes your data is in a [D3 stack format](https://github.com/d3/d3-shape#stack).
 -->
<script>
  import { area } from "d3-shape";
  import { getContext } from "svelte";

  /** @type {number | undefined} Highlight a specific data region. */
  export let selectIndex = undefined;

  export let hoveringX;

  const { data, xGet, height, xScale, yScale, zGet } = getContext("LayerCake");

  $: areaGen = area()
    .x((d) => $xGet(d))
    .y0((d) => $yScale(d[0]))
    .y1((d) => $yScale(d[1]));
</script>

<g class="area-group">
  {#each $data as d, i}
    <path
      class="path-area pointer-events-auto {selectIndex !== undefined &&
      selectIndex !== i
        ? 'opacity-50'
        : 'opacity-100'}"
      d={areaGen(d)}
      fill={$zGet(d)}
    ></path>
  {/each}
</g>

{#if hoveringX}
  <path
    d="M{$xScale(hoveringX)},0 V{$height}"
    class="stroke-zinc-400 stroke-1"
  />
{/if}
